import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import LPCover from '../../../shared/LPCover/l.p.cover.vue';
import LPThanksLetter from '../../../shared/LPThanksLetter/l.p.thanks.letter.vue';
import LPSideBySide from '../../../shared/LPSideBySide/l.p.sidebyside.vue';
import LPComparableSummary from '../../../shared/LPComparableSummary/l.p.comparable.summary.vue';
import LPCommunityMarketTrend from '../../../shared/LPCommunityMarketTrend/l.p.community.market.trend.vue';
import LPOnTheMarket from '../../../shared/LPOnTheMarket/l.p.onthemarket.vue';
import ProgressBarComponent from '../../../shared/ProgressBarComponent/progress.bar.component.vue';
import * as T_T from 'cryface';
import * as moment from 'moment';
// @ts-ignore
import jsPdf from 'jspdf';
// @ts-ignore
import { PDFDocument, ParseSpeeds, range } from 'pdf-lib';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { dataUrlToGray, baseUrlEncoder, blobToBase64 } from '../../../utils/baseurl.encoder';
import { ICmaSaveParam } from '../../../models/commons';
import { CommonFunc } from '../../../services/DataDelegate/ComonDelegate/common.functions';
import { EpicContextService } from '../../../services/EpicContextService/epic.context';
import { CallNative } from '../../../services/EpicContextService/call.native';
import { NoticeConfig } from 'iview';

@Component({
    components: {
        'layout': HybridBasicLayout,
        'rifo-progress': ProgressBarComponent,
        LPCover,
        LPThanksLetter,
        LPSideBySide,
        LPComparableSummary,
        LPCommunityMarketTrend,
        LPOnTheMarket,
    }
})
export default class ListingPresentationGeneratorMobilePage extends Vue {

    public configs = new CommonConfig();

    public isLoading = false;

    public progress = {
        text: 'Init',
        data: 0,
    };

    public urlPdfs: any[] = [];

    public dataUrlPdf: string = '';

    @Prop({ default: null })
    public data: any;

    public headerTitle = '创建成功';

    public message: string = `Listing Presentation 制作完成。\r\n如果需要修改，请访问网站 radar.rifo.ca,\r\n使用本APP账号(xxxx@xx.com)和密码登录。`;

    public coverImg: any = this.configs.cmaPicturePlaceHolder;
    public stats: any = null;
    public community = {
        propertyNew: '',
        community: '',
        city: '',
        sales: 0,
        medPrice: 0,
        avgDom: 0,
    };
    public statsAws = {
        avgPrice: [],
        medPrice: [],
        sales: [],
        doms: [],
        slrs: [],
    };
    public propertyInfo = {
        propertyType: '',
        bedrooms: '',
        bedroomsPlus: '',
        washrooms: '',
        garages: '',
        picture: '',
    };
    public clientInfo = {
        name: '',
        phoneSuffix: '+1',
        phone: '',
        salutations: '',
        email: '',
    };
    public cmaResult = {
        comparitives: [],
        prediction: {
            lower: 0,
            upper: 0,
        },
    };
    public subjectSearchText = '';
    public userInfo = {
        id: '',
        name: '',
        phone: '',
        wechat: '',
        email: '',
        website: '',
        company: null,
    };
    public sendEmail = true;
    public yonghuId = -1;
    public cmaPDFData = '';
    public onMarketProperty: any[] = [];

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    // @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    // public async onAuthenticated(val: any, oldVal: any) {
    //     if (T_T.simpleDetect(val)) {
    //         const storeInfo = await CommonFunc.getStoreInfoByYhId(val.id);
    //         const newUserInfo = {
    //             id: val.id,
    //             name: T_T.simpleDetect(val.partner.displayName) ? val.partner.displayName : '',
    //             phone: T_T.simpleDetect(val.xPhone) ? val.xPhone : '',
    //             wechat: T_T.simpleDetect(val.xWechat) ? val.xWechat : '',
    //             email: T_T.simpleDetect(val.xEmail) ? val.xEmail : '',
    //             website: T_T.simpleDetect(storeInfo.xdomain) ? `http://${storeInfo.xdomain}` : '',
    //             title: 'Salesperson',
    //             company: T_T.simpleDetect(val.partner.company) ? val.partner.company : null,
    //         };
    //         this.userInfo = newUserInfo;
    //     }
    // }

    @Watch('globalPudge.context', { immediate: true, deep: true })
    public async onEpicContext(val: any, oldVal: any) {
        const _this: any = this;
        if (T_T.simpleDetect(val)) {
            const yonghuId = EpicContextService.getParam('yonghuId');
            if (T_T.simpleDetect(yonghuId)) {
                await this.getUserInfo(yonghuId!.value);
            }
        }
    }

    // @Watch('$store.state.lpMobile.params', { immediate: true, deep: true })
    // public onStoreInput(val: any, oldVal: any) {
    //     console.log(val);
    // }

    public created() {
    }

    public async mounted() {
        if (T_T.simpleDetect(this.dataUrlPdf)) {
        } else {
            this.init();
            CallNative.runNativeFun(CallNative.ENativeFunctions.NativeSetNavTitle, {
                'title_cn': '生成报告',
                'title_en': 'New Presentation',
            });
            await this.handleGenerate();
        }
    }

    public async getUserInfo(yonghuId: any) {
        const apiHost = this.configs.authoreyHost;
        const fetched = await AxiosPromise.get(`${apiHost}/auth/detail/info?id=${yonghuId}`);
        if (fetched.errorCode === 200) {
            const val = fetched.data;
            const storeInfo = await CommonFunc.getStoreInfoByYhId(yonghuId);
            const newUserInfo = {
                id: val.id,
                name: T_T.simpleDetect(val.partner.displayName) ? val.partner.displayName : '',
                phone: T_T.simpleDetect(val.xPhone) ? val.xPhone : '',
                wechat: T_T.simpleDetect(val.xWechat) ? val.xWechat : '',
                email: T_T.simpleDetect(val.xEmail) ? val.xEmail : '',
                website: T_T.simpleDetect(storeInfo.xdomain) ? `http://${storeInfo.xdomain}` : '',
                title: 'Salesperson',
                company: T_T.simpleDetect(val.partner.company) ? val.partner.company : null,
            };
            this.userInfo = newUserInfo;
        }
    }

    public init() {
        const params = this.$store.state.lpMobile.params;
        this.clientInfo = params.clientInfo;
        this.propertyInfo = params.propertyInfo;
        this.subjectSearchText = params.subjectSearchText;
        this.stats = params.stats;
        this.cmaResult.comparitives = params.comparitives.map((v: any) => this.comparitiveMapper(v));
    }

    public async handleGenerate() {
        this.predict();
        this.setProgress('Report Generating Begin...', 0);
        this.setProgress('Generating Cover Page...', 10);
        this.isLoading = true;
        const pictureConvertPromises: Promise<any>[] = [];
        this.coverImg = await baseUrlEncoder(this.coverImg, 'image/png', 920, 600);
        this.coverImg = await dataUrlToGray(this.coverImg, 920, 600);
        const comparitives = this.cmaResult.comparitives;
        comparitives.map((v: any) => {
            if (T_T.simpleDetect(v.picture)) {
                pictureConvertPromises.push(
                    new Promise(async (resolve, reject) => {
                        v.picture = await baseUrlEncoder(v.picture, 'image/png', 140, 80);
                        resolve(1);
                    })
                );
            }
            if (T_T.simpleDetect(v.pictures)) {
                if (comparitives.length > 2) {
                    this.onMarketProperty.push({
                        id: v['MLS#:'],
                        pictures: v['pictures'].filter((pic: any) => { return v['pictures'].indexOf(pic) < 4; }),
                    });
                } else if (comparitives.length > 1) {
                    this.onMarketProperty.push({
                        id: v['MLS#:'],
                        pictures: v['pictures'].filter((pic: any) => { return v['pictures'].indexOf(pic) < 8; }),
                    });
                } else if (comparitives.length === 1) {
                    this.onMarketProperty.push({
                        id: v['MLS#:'],
                        pictures: v['pictures'],
                    });
                }
            }
        });
        for (let j = 0; j < this.onMarketProperty.length; j++) {
            for (let i = 0; i < this.onMarketProperty[j].pictures.length; i++) {
                pictureConvertPromises.push(
                    new Promise(async (resolve, reject) => {
                        this.onMarketProperty[j].pictures[i] = await baseUrlEncoder(this.onMarketProperty[j].pictures[i], 'image/png', 250, 160);
                        resolve(1);
                    })
                );
            }
        }
        const promiseRes = await Promise.all(pictureConvertPromises);
        this.$store.commit('setOnMarketProperty', this.onMarketProperty);
        this.setProgress('Generating Thanks Letter...', 25);
        await this.letsCapture();
        this.setProgress('Job Down...', 100);
        this.isLoading = false;
        this.onMarketProperty = [];
        this.$store.commit('clearOnMarketProperty');
    }

    public async letsCapture() {
        //
        const pdfDoc = new jsPdf(
            'p', 'pt', 'letter', true
        );
        const _refs: any = this.$refs;
        const p1: any = _refs.LPCover.$refs.pdf;
        const p2: any = _refs.LPThanksLetter.$refs.pdf;
        const p3: any = _refs.LPComparableSummary.$refs.pdf;
        const p4: any = _refs.LPSideBySide.$refs.pdf;
        const p5: any = _refs.LPCommunityMarketTrend.$refs.pdf;
        const p6: any = _refs.LPOnTheMarket.$refs.pdf;
        // // add option type to get the image version
        // // if not provided the promise will return
        // // the canvas.
        const zoomRate = 1.0;
        const options = {
            type: 'dataURL',
            onrendered: (canvas: any) => {
            },
            width: p1.clientWidth * zoomRate,
            height: p1.clientHeight * zoomRate,
        };
        const _this: any = this;
        const outputPages = [];
        this.setProgress('Generating ComparableSummary Page...', 45);
        await T_T.delay(2000);
        const p1Canvas = await _this.$html2canvas(p1, options);
        outputPages.push(p1Canvas);
        const p2Canvas = await _this.$html2canvas(p2, options);
        outputPages.push(p2Canvas);
        this.setProgress('Generating SideBySide Page...', 55);
        const p3Canvas = await _this.$html2canvas(p3, options);
        outputPages.push(p3Canvas);
        const p4Canvas = await _this.$html2canvas(p4, options);
        outputPages.push(p4Canvas);
        if (this.stats.length > 0) {
            this.setProgress('Generating CommunityMarketTrend Page...', 60);
            await T_T.delay(2000);
            const p5Canvas = await _this.$html2canvas(p5, options);
            outputPages.push(p5Canvas);
        }
        this.setProgress('Generating OnTheMarket Page...', 75);
        const p6Canvas = await _this.$html2canvas(p6, options);
        outputPages.push(p6Canvas);
        // const outputPages = await Promise.all([
        //     _this.$html2canvas(p1, options),
        //     _this.$html2canvas(p2, options),
        //     _this.$html2canvas(p3, options),
        //     _this.$html2canvas(p4, options),
        //     _this.$html2canvas(p5, options),
        //     _this.$html2canvas(p6, options),
        // ]);
        this.setProgress('Add Treb Market Report Page...', 80);
        pdfDoc.addImage(outputPages[0], 'png', 0, 0, pdfDoc.internal.pageSize.getWidth(), pdfDoc.internal.pageSize.getHeight(), undefined, 'MEDIUM');
        for (let i = 1; i < outputPages.length; i++) {
            pdfDoc.addPage();
            pdfDoc.addImage(outputPages[i], 'png', 0, 0, pdfDoc.internal.pageSize.getWidth(), pdfDoc.internal.pageSize.getHeight(), undefined, 'MEDIUM');
            this.setProgress(`Merging PDF...`, 80 + i * 2);
        }
        // output as pdf
        // this.dataUrlPdf = pdfDoc.output('datauristring'); // to be used to save pdf on server
        // const dataBlob = pdfDoc.output('blob');
        // const newWindowUrl = URL.createObjectURL(dataBlob);
        // merge Pdf
        const pdfMeged = await PDFDocument.create();
        const trebPdfBytes = await this.getTrebPdf();
        const cmaPdfBytes = pdfDoc.output('arraybuffer');
        const pdfToMergeBytes = [];
        pdfToMergeBytes.push(cmaPdfBytes);
        pdfToMergeBytes.push(trebPdfBytes);
        this.setProgress('Saving Report...', 98);
        for (let i = 0; i < pdfToMergeBytes.length; i++) {
            const pdf = await PDFDocument.load(pdfToMergeBytes[i], { parseSpeed: ParseSpeeds.Fastest });
            let pages = [0, 1, 2, 3, 4];
            try {
                pages = range(0, pdf.getPages().length);
            } catch (e) { }
            const copiedPages = await pdfMeged.copyPages(pdf, pages);
            copiedPages.map((page) => {
                pdfMeged.addPage(page);
            });
        }
        const arrayBuffer: Uint8Array = await pdfMeged.save();
        const pdfUrl = URL.createObjectURL(
            new Blob([arrayBuffer], { type: 'application/pdf' }),
        );
        this.urlPdfs.push(pdfUrl);
        const responseData = await this.saveCMAOnServer();
        if (T_T.simpleDetect(responseData.filePath)) {
            this.dataUrlPdf = responseData.filePath;
        } else {
            console.error('PDF Save Failed, File Path Not Found.');
        }
    }

    public preview() {
        window.open(`${this.dataUrlPdf}`);
    }

    public downloadPDFHref(dataURI: string | null) {
        if (dataURI) {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            const byteString = atob(dataURI.split(',')[1]);

            // separate out the mime component
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to an ArrayBuffer
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            const convertedUrl = window.URL.createObjectURL(new Blob([ab], { type: mimeString }));
            return convertedUrl;
        }
    }

    public async getTrebPdf(): Promise<ArrayBuffer | null> {
        const apiHost = this.configs.apiHost;
        const year = new Date().getFullYear();
        const month = new Date().getMonth() > 10 ? `${new Date().getMonth()}` : `0${new Date().getMonth()}`;
        const fetched = await AxiosPromise.get(`${apiHost}/commons/cma/report/treb?month=${year}${month}`);
        // console.log(`${apiHost}/commons/cma/report/treb?month=${year}${month}`);
        if (fetched.errorCode === 200) {
            const pdfNetwork: Response = await fetch(fetched.data);
            const arrayBuffer: ArrayBuffer = await pdfNetwork.arrayBuffer();
            return arrayBuffer;
        } else {
            return null;
        }
    }

    public predict() {
        const prices: number[] = [];
        this.cmaResult.comparitives.map((cm: any) => {
            if (T_T.simpleDetect(cm['Price'])) {
                prices.push(Number(cm['Price']));
            } else if (T_T.simpleDetect(cm['List Price'])) {
                prices.push(Number(cm['List Price']));
            }
        });
        if (prices.length > 0) {
            const prediction = T_T.nDis(1.96, prices);
            this.cmaResult.prediction = {
                lower: Math.round(prediction[0]) * 1.05,
                upper: Math.round(prediction[1]) * 1.05,
            };
        }
    }

    public beforeDestroy() {
        this.urlPdfs.map((url: any) => {
            URL.revokeObjectURL(url);
        });
    }


    public comparitiveMapper(comparitive: any) {
        if (T_T.simpleDetect(comparitive.pictures)) {
            if (comparitive.pictures) {
                comparitive.picture = comparitive.pictures[0];
            } else {
                comparitive.picture = null;
            }
        }
        const addressCma = T_T.simpleDetect(comparitive.addressCma) ?  comparitive.addressCma : {};
        return {
            'title': 'Comparative Sold',
            'MLS#:': this.detectNull(comparitive.mlsNumber),
            'List Price': this.detectNull(comparitive.price),
            'Price': this.detectNull(comparitive.soldPrice),
            'Address:': T_T.simpleDetect(addressCma)
                ? `${addressCma.streetNumber || ''} ${addressCma.streetName || ''} ${addressCma.suffix || ''}` : '',
            // 'Municipality:': 'Toronto',
            'Community:': this.detectNull(comparitive.community),
            'Listing Type': this.detectNull(comparitive.listingType),
            'Brokerage': this.detectNull(comparitive.brokerageCma),
            'List Entry Date': moment(this.detectNull(comparitive.listEntryDate)).format(this.configs.dateFormat),
            'Sold Date': moment(this.detectNull(comparitive.soldDate)).format(this.configs.dateFormat),
            'DOM': `${moment(this.detectNull(comparitive.soldDate)).diff(moment(this.detectNull(comparitive.listEntryDate)), 'days')}`,
            'Postal Code:': this.detectNull(addressCma.postalCode),
            'Cross Streets:': this.detectNull(addressCma.crossStreets),
            'PropertyType:': this.detectNull(comparitive.propertyType),
            'Ownership': this.detectNull(comparitive.ownership),
            'Bedrooms': this.detectNull(comparitive.bedrooms),
            'Bedroom plus': this.detectNull(comparitive.bedroomsPlusCma),
            'Washrooms': this.detectNull(comparitive.washrooms),
            'Garages': this.detectNull(comparitive.garages),
            'ApproxAge': this.detectNull(comparitive.approxAge),
            'Basements': T_T.simpleDetect(comparitive.basements) ? comparitive.basements.join(', ') : '',
            'Storey': this.detectNull(comparitive.storey),
            'BuiltYear': this.detectNull(comparitive.builtYears),
            'Lot Area': this.detectNull(this.decodeArea(comparitive.lotArea)),
            'Usage Area': this.detectNull(this.decodeArea(comparitive.usageArea)),
            'picture': comparitive.picture,
            'pictures': T_T.simpleDetect(comparitive.pictures) ? comparitive.pictures : [],
            'selected': true,
        };
    }

    public detectNull(prop: any) {
        if (T_T.simpleDetect(prop)) {
            return `${prop}`;
        } else {
            return '';
        }
    }

    public decodeArea(area: any) {
        if (T_T.simpleDetect(area)) {
            if (T_T.simpleDetect(area.value)) {
                if (T_T.simpleDetect(area.value.x)) {
                    if (T_T.simpleDetect(area.value.unit)) {
                        return `${Math.round(area.value.x * area.value.y)} sq ${area.value.unit || ''}`;
                    } else {
                        return `${Math.round(area.value.x * area.value.y)}`;
                    }
                }
                if (T_T.simpleDetect(area.value.from)) {
                    return `${area.value.from}-${area.value.to} ${area.value.unit || ''}`;
                }
            }
        } else {
            return area;
        }
        return undefined;
    }

    public async saveCMAOnServer() {
        const apiHost = this.configs.apiHost;
        const pdfNetwork: Response = await fetch(this.urlPdfs[this.urlPdfs.length - 1]);
        const pdfBlob: Blob = await pdfNetwork.blob();
        let pdfBase64: any = await blobToBase64(pdfBlob);
        pdfBase64 = pdfBase64.replace('data:application/pdf;base64,', '');
        const postBody: ICmaSaveParam = {
            cmaCreateParams:
            {
                propertyInfo: this.propertyInfo,
                clientInfo: this.clientInfo,
                cmaRecords: this.cmaResult.comparitives.map((re: any) => `${re['MLS#:']}`).join(','),
                subjectSearchText: this.subjectSearchText,
                community: this.community,
                statsAws: this.statsAws,
                userInfo: this.userInfo,
            },
            yonghuId: this.userInfo.id,
            cmaPDFData: pdfBase64,
            sendEmail: this.sendEmail,
        };
        // alert(JSON.stringify(postBody));
        // console.log(JSON.stringify(postBody));
        try {
            const fetched = await AxiosPromise.postJson(`${apiHost}/agent/listing/presentation/creation`, postBody);
            await this.agentLog();
            await this.workflowDone();
            // console.log(fetched);
            if (fetched.status === 200) {
                if (fetched.data.errorCode === 200) {
                    return fetched.data.data;
                }
            }
            return fetched;
        } catch (e) {
            const noticeConfig: NoticeConfig = {
                title: 'Generate PDF Failed',
                desc: 'Please Contact Customer Service.',
            };
            this.$Notice.error(noticeConfig);
            return null;
        }
        // const fetched = await AxiosPromise.postJson(`http://192.168.0.40:9528/radar-api/agent/listing/presentation/creation`, postBody);
        // console.log(fetched);
    }

    public setProgress(text: string, value: number) {
        this.progress.text = text;
        this.progress.data = value;
    }

    public complete() {
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeClose, {});
    }

    public async agentLog() {
        const apiHost = this.configs.cimsServHost;
        const activityId = this.globalPudge.functions.getParam('activityId');
        if (T_T.simpleDetect(activityId)) {
            const postBody = {
                activityId: activityId!.value,
                ltype: 1,
            };
            const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/agentLog/insert`, postBody);
            // console.log(fetched);
        } else {
            console.log('EpicContext Error: Empty activityId--------------------------------------------');
        }
    }

    public async workflowDone() {
        const apiHost = this.configs.cimsServHost;
        const activityId = this.globalPudge.getParam('activityId');
        const entrustId = this.globalPudge.getParam('entrustId');
        if (T_T.simpleDetect(activityId) && T_T.simpleDetect(entrustId)) {
            const fetched = await AxiosPromise.get(`${apiHost}/bimsEntrust/doneWorkFlow?activityId=${activityId}&entustId=${entrustId}&ltype=1&forceDone=1`);
            // console.log(fetched);
        } else {
            console.log('EpicContext Error: Empty activityId or entrustId--------------------------------------------');
        }
    }

    public onClipboardPdf() {
        const noticeConfig: NoticeConfig = {
            title: 'Success',
            desc: '复制成功'
        };
        this.$Notice.success(
            noticeConfig
        );
    }

}
